module.exports = __webpack_public_path__ + "img/france-respiratory-diseases-female.3bca138e.png";